export * from "./tenant.web-repository"
export * from "./tenant-api-urls"